import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginPageComponent} from './components/login-page/login-page.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {AuthGuardService as AuthGuard} from './auth/auth-guard.service';
import {AnnouncementsComponent} from './components/announcements/announcements.component';

const routes: Routes = [
  {path: '', component: LoginPageComponent},
  {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
  {path: 'announcements', component: AnnouncementsComponent, canActivate: [AuthGuard]},
  {
    path: 'forms',
    loadChildren: () => import('./modules/forms/evaluation-forms.module').then(m => m.EvaluationFormsModule),
    canActivate: [AuthGuard]
  },
  {path: '**', redirectTo: '', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
